import { useEffect, useRef } from 'react';
import ArtImage from './ArtImage';
import { registerTurn } from '../lib/turn';

/**
 * Hand-drawn artwork used as colour around the site (files come from `npm run art`).
 *
 *  <Peek/>    a mandala that peeks in from the left or right margin of a section
 *             and turns slowly as the page scrolls
 *  <Horizon/> a skyline / landscape strip that runs along the bottom of a section
 *
 * `name` is one of: capitalism, education, environmentalism, immigration.
 */

const HORIZON_ASPECT = { capitalism: 7.115, education: 4.663, environmentalism: 4.639, immigration: 5.488 };

export function Peek({ name, side = 'right', top = '8%', turn = 1 }) {
  const ref = useRef(null);
  useEffect(() => registerTurn(ref.current, turn), [turn]);
  return (
    <div ref={ref} className={`peek peek--${side}`} style={{ top }} aria-hidden="true">
      <ArtImage
        className="peek-img"
        base={`img/art/${name}-mandala`}
        widths={[480, 900]}
        sizes="(max-width: 860px) 210px, 24vw"
      />
    </div>
  );
}

export function Horizon({ name }) {
  return (
    <div className="horizon" aria-hidden="true">
      <ArtImage
        className="horizon-img"
        base={`img/art/${name}-horizon`}
        widths={[900, 1800]}
        aspect={HORIZON_ASPECT[name] || 5}
        sizes="100vw"
      />
    </div>
  );
}

/** Splits a section's artwork rows into its mandalas and its (single) skyline strip. */
export function splitArt(items = []) {
  return { peeks: items.filter((i) => i.style === 'mandala'), horizon: items.find((i) => i.style === 'skyline') || null };
}

export function Peeks({ items }) {
  return items.map((p) => <Peek key={p.key} name={p.name} side={p.side} top={p.top} turn={p.turn} />);
}
